(function loloyalVIPIcon() {
  const target = document.querySelector('.header-loloyal-vip-link__icon');
  
  if (target) {
    target.addEventListener('click', function() {
      const url = window.location.href;
      if (!url.includes('#loloyal-home')) {
        window.location.href = url.split('#')[0] + '#loloyal-home';
      }
    });
  }
})();